module.exports = __webpack_public_path__ + "static/c3-dc1fc0666b9f14bce0ce87fdba2c8dce.jpg";